/* eslint-disable */
// 自身のログイン状態をチェックする
//* eslint-disable */
import {
    //AmazonCognitoIdentity,
    CognitoUserPool //,
    //CognitoUser,
    //AuthenticationDetails 
} from 'amazon-cognito-identity-js'


import axios from 'axios'
import { ref } from 'vue'

import { useRouter, useRoute } from 'vue-router'
import { number } from 'yup';
const route = useRoute();


let youbi_list = [ "日", "月", "火", "水", "木", "金", "土" ]
const GlobalData = {
    $User_email: null,  // メールアドレス
    user_id: null,      // ユーザID
    shakyouser_code: null, // 社協の利用者コード
    kencd: null,        // 県コード
    city: null,         // 市町村名
    kengen: null,       // 権限
    shakyo_code: null,   // ユーザーが所属する社協の英名
    $ID_Token: {headers: {"Authorization": ""}},    // 認証用IDトークン格納ヘッダー

    /* 利用者が利用するフラグ */
    designated_city:false,
    shakyouser_gamen:[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
    shakyouser_program:[],
    shakyouser_jizen:[],
    shakyouser_jigo:[],
    shakyouser_facility:[],

    shakyo:null,// URLの社協英名・社協コード
    choson_code:null,// 市区町村コード（社協英名を使ってAPIから取得）

    /* 本番環境用 */
    $UserPoolId: 'ap-northeast-1_3OHgw3311',//ログインユーザープールID（cognito）
    $ClientId: '3gi6k740mjirrs9asa5qro381e',//ログインクライアントID（cognito）
    $social_ClientId: 'vit7up9ka6gsgfa1q3fn2pkda',//ソーシャルログインクライアントID（cognito）
    $IdentityPoolId: 'ap-northeast-1:7cccd05d-44bd-4c61-9e06-15cc02bc823c',
    $API_URL:'https://www.volukatsu-yell.jp/dev/',//APIのURL・テスト用
   // $API_URL:'https://www.volukatsu-yell.jp/prod/',//APIのURL・本番用
    $CODE_URL:'https://www.volukatsu-yell.jp/',//QRコードのURL 
    $CSV_bucket:'volukatu-file',//CSVファイル（アンケート・報告書回答）のアップロード先
    $Image_bucket:'volukatu-images',//画像のアップロード先 
    $Ninsho_mail:'@volukatsu-yell.jp',
    $fileupload_url:"https://iqxmjhvxsobcs27kn4tsu7sxie0kwkbd.lambda-url.ap-northeast-1.on.aws/",
    /* 本番環境用ここまで */

    /* キテル（開発）環境用 */
     /*
    $UserPoolId: 'ap-northeast-1_6hWWd14Fy',//ログインユーザープールID（cognito）
//    $ClientId: 'athmhjnaevim1oel849bvg145', //ログインクライアントID（cognito）
    $ClientId: '4sdlml7a8v25nc1ugjvpckk65q',//ログインクライアントID（cognito）
    $cognitoDomain:'ap-northeast-1.amazoncognito.com',// Cognitoドメイン
    $IdentityPoolId: 'ap-northeast-1:d026f009-3ac3-4eef-8b41-4da0d048f8de',
    $API_URL:'https://www.volukatsu-taiken.net/dev/',//APIのURL・テスト用
//    $API_URL:'https://d19ywb8a0wx267.cloudfront.net/dev/',//APIのURL・テスト用
//    $API_URL:'https://d19ywb8a0wx267.cloudfront.net/prod/',//APIのURL・本番用
    $CODE_URL:'https://www.volukatsu-taiken.net/',//QRコードのURL  
    $CSV_bucket:'taiken-program',//CSVファイル（テンプレート）のアップロード先
    $Image_bucket:'volukatsu-images',//画像や証明書のアップロード先
    $Ninsho_mail:'@kitel.co.jp', 
    $fileupload_url:"https://bnkvulbfw2vvde7wns7kvpz2uq0byeik.lambda-url.ap-northeast-1.on.aws/",
    // $CODE_URL:'https://d1ewnd11x82mw8.cloudfront.net',//QRコードのURL  
    */
    /* キテル（開発）環境用ここまで */

    $Address_ken_list:["都道府県",//都道府県名のリスト
        "北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県",
        "茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県",
        "新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県",
        "静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県",
        "奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県",
        "徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県",
        "熊本県","大分県","宮崎県","鹿児島県","沖縄県"],

    $saitama_list : [ // 埼玉県内の市区町村コードと市区町村名
        ["11100","さいたま市"],
        ["11101","さいたま市西区"],
        ["11102","さいたま市北区"],
        ["11103","さいたま市大宮区"],
        ["11104","さいたま市見沼区"],
        ["11105","さいたま市中央区"],
        ["11106","さいたま市桜区"],
        ["11107","さいたま市浦和区"],
        ["11108","さいたま市南区"],
        ["11109","さいたま市緑区"],
        ["11110","さいたま市岩槻区"],
        ["11201","川越市"],
        ["11202","熊谷市"],
        ["11203","川口市"],
        ["11206","行田市"],
        ["11207","秩父市"],
        ["11208","所沢市"],
        ["11209","飯能市"],
        ["11210","加須市"],
        ["11211","本庄市"],
        ["11212","東松山市"],
        ["11214","春日部市"],
        ["11215","狭山市"],
        ["11216","羽生市"],
        ["11217","鴻巣市"],
        ["11218","深谷市"],
        ["11219","上尾市"],
        ["11221","草加市"],
        ["11222","越谷市"],
        ["11223","蕨市"],
        ["11224","戸田市"],
        ["11225","入間市"],
        ["11227","朝霞市"],
        ["11228","志木市"],
        ["11229","和光市"],
        ["11230","新座市"],
        ["11231","桶川市"],
        ["11232","久喜市"],
        ["11233","北本市"],
        ["11234","八潮市"],
        ["11235","富士見市"],
        ["11237","三郷市"],
        ["11238","蓮田市"],
        ["11239","坂戸市"],
        ["11240","幸手市"],
        ["11241","鶴ヶ島市"],
        ["11242","日高市"],
        ["11243","吉川市"],
        ["11245","ふじみ野市"],
        ["11246","白岡市"],
        ["11301","伊奈町"],
        ["11324","三芳町"],
        ["11326","毛呂山町"],
        ["11327","越生町"],
        ["11341","滑川町"],
        ["11342","嵐山町"],
        ["11343","小川町"],
        ["11346","川島町"],
        ["11347","吉見町"],
        ["11348","鳩山町"],
        ["11349","ときがわ町"],
        ["11361","横瀬町"],
        ["11362","皆野町"],
        ["11363","長瀞町"],
        ["11365","小鹿野町"],
        ["11369","東秩父村"],
        ["11381","美里町"],
        ["11383","神川町"],
        ["11385","上里町"],
        ["11408","寄居町"],
        ["11442","宮代町"],
        ["11464","杉戸町"],
        ["11465","松伏町"],
        ["00001","テスト１"],
        ["00002","テスト２"],
        ["00003","テスト３"],
        ["00004","テスト４"],
        ["00005","テスト５"],
        ["00006","テスト６"],
        ["00007","テスト７"],
        ["00008","テスト８"],
        ["00009","テスト９"],
        ["00010","テスト１０"],
        ["00011","テスト１１"],
        ["11100-2","さいたま市"],
        ["11101-2","さいたま市西区"],
        ["11102-2","さいたま市北区"],
        ["11103-2","さいたま市大宮区"],
        ["11104-2","さいたま市見沼区"],
        ["11105-2","さいたま市中央区"],
        ["11106-2","さいたま市桜区"],
        ["11107-2","さいたま市浦和区"],
        ["11108-2","さいたま市南区"],
        ["11109-2","さいたま市緑区"],
        ["11110-2","さいたま市岩槻区"],
        ["11201-2","川越市"],
        ["11202-2","熊谷市"],
        ["11203-2","川口市"],
        ["11206-2","行田市"],
        ["11207-2","秩父市"],
        ["11208-2","所沢市"],
        ["11209-2","飯能市"],
        ["11210-2","加須市"],
        ["11211-2","本庄市"],
        ["11212-2","東松山市"],
        ["11214-2","春日部市"],
        ["11215-2","狭山市"],
        ["11216-2","羽生市"],
        ["11217-2","鴻巣市"],
        ["11218-2","深谷市"],
        ["11219-2","上尾市"],
        ["11221-2","草加市"],
        ["11222-2","越谷市"],
        ["11223-2","蕨市"],
        ["11224-2","戸田市"],
        ["11225-2","入間市"],
        ["11227-2","朝霞市"],
        ["11228-2","志木市"],
        ["11229-2","和光市"],
        ["11230-2","新座市"],
        ["11231-2","桶川市"],
        ["11232-2","久喜市"],
        ["11233-2","北本市"],
        ["11234-2","八潮市"],
        ["11235-2","富士見市"],
        ["11237-2","三郷市"],
        ["11238-2","蓮田市"],
        ["11239-2","坂戸市"],
        ["11240-2","幸手市"],
        ["11241-2","鶴ヶ島市"],
        ["11242-2","日高市"],
        ["11243-2","吉川市"],
        ["11245-2","ふじみ野市"],
        ["11246-2","白岡市"],
        ["11301-2","伊奈町"],
        ["11324-2","三芳町"],
        ["11326-2","毛呂山町"],
        ["11327-2","越生町"],
        ["11341-2","滑川町"],
        ["11342-2","嵐山町"],
        ["11343-2","小川町"],
        ["11346-2","川島町"],
        ["11347-2","吉見町"],
        ["11348-2","鳩山町"],
        ["11349-2","ときがわ町"],
        ["11361-2","横瀬町"],
        ["11362-2","皆野町"],
        ["11363-2","長瀞町"],
        ["11365-2","小鹿野町"],
        ["11369-2","東秩父村"],
        ["11381-2","美里町"],
        ["11383-2","神川町"],
        ["11385-2","上里町"],
        ["11408-2","寄居町"],
        ["11442-2","宮代町"],
        ["11464-2","杉戸町"],
        ["11465-2","松伏町"],
        ["00001-2","テスト１"],
        ["00002-2","テスト２"],
        ["00003-2","テスト３"],
        ["00004-2","テスト４"],
        ["00005-2","テスト５"],
        ["00006-2","テスト６"],
        ["00007-2","テスト７"],
        ["00008-2","テスト８"],
        ["00009-2","テスト９"],
        ["00010-2","テスト１０"],
        ["00011-2","テスト１１"]],

    $Kotsu_list:["",  //交通手段（個人・団体）のリスト（１：自家用車、２：バイク、３：自転車、４：電車／バス、５：徒歩）
                 "自家用車","バイク","自転車","電車／バス","徒歩"],

    $Shokugyo_kbn_list:["",  //職業区分（個人）のリスト（１：学生、２：勤労者、９：その他）
                 "学生","勤労者","","","","","","","その他"],

    $Hoken_plan_list:["",//ボランティア活動保険プラン（個人）のリスト（１：基本、２：天災・地震補償、３：特定感染症重点）
                 "基本","天災・地震補償","特定感染症重点"],

    $Dantai_syurui_list:["",//種類（団体）のリスト（１：社協、２：団体、３：管理団体）
                 "社協","団体","管理団体"],

    $Iraisha_syurui_list:["",//依頼者（ボランティア活動）のリスト（１：個人、２：団体）
                 "個人","団体"],
                      
    $Taisho_list:["",//対象者（ボランティア活動）のリスト（１：身体障碍者、２：知的障碍者、３：精神障碍者、４：高齢、５：徒歩、９：その他）
                    "身体障碍者","知的障碍者","精神障碍者","高齢","児童","","","","その他"],
                    
    // 祝日を取得するAPIを呼び出すためのシークレットキー
    $holiday_key : 'AIzaSyBAyiDQTDocEEfUKIH67I_dKh6LzzOg26k',

    // 通信エラー時メッセージ
    $axios_error : "通信エラーが発生しました。画面を再読み込みしてください。",
}

// 各コンポーネント内の<script>タグ内でグローバル変数を参照するための関数
const getUser_email = function() {// ログインユーザーのメールアドレス
    return GlobalData.$User_email
};

    // URLを絶対パスで指定
    let login_url = location.protocol+"//"+location.host+"/"+GlobalData.shakyo+"/Kanri/MailLogin"
    async function login_check (){
        login_url = location.protocol+"//"+location.host+"/"+GlobalData.shakyo+"/Kanri/MailLogin"
        try {
            const res = await axios.post("/dev/auth_me", {}, { withCredentials: true });
            const user = res.data; // ← axiosでは .data から取得
        //    alert("ユーザー情報:"+JSON.stringify(user));

            GlobalData.$User_email = user.email
            GlobalData.$profile = JSON.parse(user.attributes)
            const profile = GlobalData.$profile
            if(profile.user_id) GlobalData.user_id = profile.user_id
            if(profile.shakyouser_code) GlobalData.shakyouser_code = profile.shakyouser_code
            if(profile.kencd) GlobalData.kencd = profile.kencd
            if(profile.city) GlobalData.city = profile.city
            if(profile.shakyo_code) GlobalData.shakyo_code = profile.shakyo_code
            
            GlobalData.kengen = profile.kengen
            if(profile.kengen == "Ippan" || profile.kengen == "ippan"){
                // 一般権限の場合はログアウトしてから画面に移動する
                logout()
                location.href=login_url
            }

            // 管理者（Admin・kanri）・利用者（shakyouser）・マスター（master）の場合
            if(profile.kengen == "Admin" || profile.kengen == "admin" || 
               profile.kengen == "Kanri" || profile.kengen == "kanri" || 
               profile.kengen == "master" || profile.kengen == "master" || 
               profile.kengen == "Shakyouser" || profile.kengen == "shakyouser"  
            ){
                // マスター権限以外の場合
                if(profile.kengen != "master" && profile.kengen != "master" ){
                    // 社協が違っていたらログイン画面に移動する
                    if(profile.shakyo_code != GlobalData.shakyo){
                        logout()
                        location.href=login_url
                    }
                }

                    // 社協英名から政令都市向けオプション適用済みかどうかを取得
                    axios.post(GlobalData.$API_URL+"Shakyo_read", 
                            {shakyo:GlobalData.shakyo}
                            ).then(response => {
                            GlobalData.designated_city = response.data.designated_city

                            // 適用済み
                            if(response.data.designated_city){
                                // 権限が利用者の場合
                                if(profile.kengen == "Shakyouser" || profile.kengen == "shakyouser"){

                                    shakyouser_check(profile.user_id)
                                    
                                }else{
                                    // 権限が管理者の場合は全ての画面を利用できる
                                    GlobalData.shakyouser_gamen = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                                }
                            }else{
                                // 適用していないなら利用者は管理者と同様にすべての機能を利用可
                                GlobalData.shakyouser_gamen = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                            }
                        
                    }).catch(error => {
                        console.log(error)
                        GlobalData.shakyouser_gamen = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1]
                        
                    })

            }

            if(profile.kengen.toLowerCase() == "shisetsu"){
                // 施設権限の場合はログイン画面に移動する
                location.href=login_url
            }


            //return user;
        } catch (err) {
            console.log("ユーザー情報取得失敗:"+JSON.stringify(err.response) || err);
            logout()
            location.href=login_url
            //return null;
        }
    }

    // 利用者の利用可能設定を取得
    let Detailread_error = 0
    let shakyouser_check = function(){
        axios.post(GlobalData.$API_URL + "Shakyouser_read",
        {
            shakyouser_id: GlobalData.user_id ,    
        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            let ret = response.data
            let info = ret.shakyouser_info
            //正常な結果が返ってきた場合の処理
            if(ret.status == 1){
                alert("エラーが発生しました。\n")
            }else{
                if(info.shakyouser_gamen) GlobalData.shakyouser_gamen  = info.shakyouser_gamen.split(",").map(Number)
                if(info.shakyouser_program) GlobalData.shakyouser_program  = info.shakyouser_program.split(",").map(Number)
                if(info.shakyouser_jizen) GlobalData.shakyouser_jizen  = info.shakyouser_jizen.split(",").map(Number)
                if(info.shakyouser_jigo) GlobalData.shakyouser_jigo  = info.shakyouser_jigo.split(",").map(Number)
                if(info.shakyouser_facility) GlobalData.shakyouser_facility  = info.shakyouser_facility.split(",").map(Number)
            }
            console.log(GlobalData.shakyouser_gamen)
            console.log(GlobalData.shakyouser_program)
            console.log(GlobalData.shakyouser_jizen)
            console.log(GlobalData.shakyouser_jigo)
            console.log(GlobalData.shakyouser_facility)
        })
        .catch(error => {  
            if(Detailread_error == 6){
                alert(error + GlobalData.$axios_error)
            }else{
                Detailread_error++
                setTimeout(function(){shakyouser_check()},"1000")
            }
        })
    }

    let cognitoUser = {}
/*
const login_check_ippan = function(cityname) {//ログイン状態のチェック
   
    let poolData = {
        UserPoolId: GlobalData.$UserPoolId, // Your user pool id here
        ClientId: GlobalData.$ClientId, // Your client id here
    };
    
    let userPool = new CognitoUserPool(poolData);
    cognitoUser = userPool.getCurrentUser();
    
    try{
        // Cognitoセッション情報の取得
        cognitoUser.getSession(function (err, session) {
            // 認証用IDトークンの取得およびヘッダーに格納
            GlobalData.$ID_Token = {headers: {"Authorization":session.idToken.jwtToken}};
            GlobalData.$Access_Token = {headers: {"Autorization":session.accessToken.jwtToken}};
        });
        
        cognitoUser.getUserAttributes(function(err, result) {
            if (err) {
                // ログインしていない場合はログイン画面に移動する
                if(cityname == null){
                    location.href="/login"
                }else{
                    location.href="/"+cityname+"/Volunteer/login"
                }
                return;
            }
            // 送られてきた値のNameがemailだったら、valueからメールアドレスを取り出す
            //GlobalData.$User_email = result[2].getValue();

            for (var i = 0; i < result.length; i++) {

                if (result[i].getName() == "email") {
                    GlobalData.$User_email = result[i].getValue()
                }
                if (result[i].getName() == "profile") {
                    GlobalData.$profile = result[i].getValue()
                    let profile = JSON.parse(GlobalData.$profile)
                    GlobalData.user_id = profile.user_id
                    GlobalData.kencd = profile.kencd
                    GlobalData.city = profile.city
                    GlobalData.kengen = profile.kengen
                    GlobalData.shakyo_code = profile.shakyo_code
                    if(profile.kengen != "Admin" && profile.kengen != "admin"){
                        if(cityname == null){
                            location.href="/login"
                        }else{
                            location.href="/"+cityname+"/Volunteer/login"
                        }
                    }
                    
                    if(profile.shakyo_code != GlobalData.shakyo){
                        if(cityname == null){
                            location.href="/login"
                        }else{
                            location.href="/"+cityname+"/Volunteer/login"
                        }
                    }
                }

            }

        
        });
        //
        //
    } catch (e){
        
       // alert("login NG");
        // ログインしていない場合はログイン画面に移動する
        if(cityname == null){
            location.href="/login"
        }else{
            location.href="/"+cityname+"/Volunteer/login"
        }
    }

}
*/
//—- ログアウト —------------------------------------------
const logout = async () => {
    
    /*
    //const redirectUrl = "http://localhost:8080/signout";
    const logoutUrl =
        `https://${GlobalData.$cognitoDomain}/logout?client_id=${GlobalData.$ClientId}&logout_uri=${login_url}`;*/
    const login_url = location.protocol+"//"+location.host+"/"+GlobalData.shakyo+"/Kanri/MailLogin"

    try {
        await axios.post("/dev/logout_lambda", {}, { withCredentials: true });
        //alert("ログアウトしました。");
        GlobalData.$User_email = null
        GlobalData.user_id = null
        GlobalData.kencd = null
        GlobalData.city = null
        GlobalData.kengen = null
       // window.location.href = login_url;

    } catch (err) {
        console.error(err);
        console.log("ログアウト失敗");
    }
};
   //年月日の表示を整える
   let DateSetting = function(changedate){

    if(changedate != null){
        

        // 曜日配列
        const youbi_list = ["日","月","火","水","木","金","土"]
        
        let date = Date.parse(changedate);
        let set_date = new Date(date);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
        set_date = new Date(set_date);
        
        return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）";
    }else{
        return
    }
 }
 //時間の表示を整える
 let TimeSetting = function(changetime){
  if(changetime != null){
      
      return changetime.slice( 0, 5 );
  }else{
      return ""
  }

 }
 
  //年月日＋時間の表示を整える(EU時間)
  let EuDateSetting = function(changedate){
     /*
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours()-8);
 */
     let eudate = Date.parse(changedate);
     let eu_set_date = new Date(eudate);
     eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     eu_set_date = new Date(eu_set_date);
     eu_set_date.setHours(eu_set_date.getHours()-9);
 
     const set_month = eu_set_date.getMonth()+1
 
     // 日時から日と時をそれぞれ抜き出す
     let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
     let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
 
     let return_date = new Date(day + " "+time)
     return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     return_date = new Date(return_date);
 
     return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"
  }
  //年月日＋時間の表示を整える
  let DateTimeSetting = function(changedate){
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours());
 
     //return date;
     return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+") "+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
  }
  //年月日＋時間の表示を整える(EU時間)
  let EuDateTimeSetting = function(changedate){
     /*
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours()-8);
 */
     let eudate = Date.parse(changedate);
     let eu_set_date = new Date(eudate);
     eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     eu_set_date = new Date(eu_set_date);
     eu_set_date.setHours(eu_set_date.getHours()-9);
 
     const set_month = eu_set_date.getMonth()+1
 
     // 日時から日と時をそれぞれ抜き出す
     let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
     let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
 
     let return_date = new Date(day + " "+time)
     return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     return_date = new Date(return_date);
 
     return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"+ ('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2)
  }

  //〆切日を整える
  let ShimekiriSetting = function(changedate){
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours());
 
     //return date;
     return set_date
  }
 //〆切日を整える(EU時間)
 let EuShimekiriSetting = function(changedate){

    let eudate = Date.parse(changedate);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours()-9);
    
    const set_month = eu_set_date.getMonth()+1
    
    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);

    return return_date
    /*
    
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours()-8);
    */

    //return set_date;
 }
const Search_timestamp = function(timestamp){// 各検索の「更新日時」の計算
    /*
    let date = Date.parse(timestamp);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours() );
    return set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2)+" "+('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2);

    */
   
    let eudate = Date.parse(timestamp);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours()-9);
    
    const set_month = eu_set_date.getMonth()+1
    
    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);
    return return_date.getFullYear()+"-"+('00'+(return_date.getMonth()+1)).slice(-2)+"-"+('00'+return_date.getDate()).slice(-2)+" "+('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2);

}

  // 曜日の順番を入れ替える
  let youbi_irekae = function(set_youbi){

    if(set_youbi != null){
        
        // 表示したい並び順
        const order = ["月", "火", "水", "木", "金", "土", "日", "祝"];

        // 上の並び順に合わせて、「、」区切りで並び替える
        const after = set_youbi
        .split("、")
        .sort((a, b) => order.indexOf(a) - order.indexOf(b))
        .join("、");

        console.log(set_youbi+"→"+after)
        
        return after
    }
  }

 // 開催日を整える
let Kaisai_setting = function(chengedate){

    let kaisai_date = Date.parse(chengedate);
    let set_kaisai_date = new Date(kaisai_date);
    set_kaisai_date = set_kaisai_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_kaisai_date = new Date(set_kaisai_date);
    console.log("set_kaisai_date:"+set_kaisai_date)
    return set_kaisai_date.getFullYear()+"-"+(set_kaisai_date.getMonth()+1)+"-"+set_kaisai_date.getDate()

}

// 一般ユーザーの追加
const set_habitat = (user_id,kencd,city,kengen) => {
    let attributeList = [
        {
            Name: 'profile',
            Value: '{"user_id":'+user_id+',"kencd":'+kencd+',"city":"'+city+'","kengen":"'+kengen+'"}'
        } //,
		//{
        //    Name: 'address',
        //    Value: kencd + ',' + city
        //}
    ]
    cognitoUser.updateAttributes(attributeList,
        function(err, result) {
            if (err) {
            //    console.log(err.message || JSON.stringify(err));
                return;
            }
          //  console.log("updateAttribute result:"+result)
            login_check()
    });
}
export { GlobalData, getUser_email, login_check, logout,DateSetting,EuDateSetting,DateTimeSetting,EuDateTimeSetting,ShimekiriSetting,EuShimekiriSetting,TimeSetting, Search_timestamp, set_habitat,youbi_irekae, Kaisai_setting }
